import { render, staticRenderFns } from "./sendModal.vue?vue&type=template&id=d7e94610&scoped=true&"
import script from "./sendModal.vue?vue&type=script&lang=js&"
export * from "./sendModal.vue?vue&type=script&lang=js&"
import style0 from "./sendModal.vue?vue&type=style&index=0&id=d7e94610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e94610",
  null
  
)

export default component.exports